import { Button, SofiaMark } from "@coval/ui"
import { ArrowLeft, CircleAlert } from "lucide-react"

import { reportClass } from "./ReportStyles"

export function ReportEmptyState({
  modelAvailable,
}: {
  modelAvailable: boolean
}) {
  return (
    <div className={reportClass("empty-state")}>
      <span className={reportClass("empty-mark")}>
        <SofiaMark size={48} />
      </span>
      <div className={reportClass("eyebrow")}>A Sofia notebook</div>
      <h2>Your agents, explained.</h2>
      <p>
        Understand observed changes and where to focus next. Sofia turns your
        agents’ performance into a notebook you can keep shaping.
      </p>
      <div className={reportClass("empty-features")}>
        <div>
          <span>01</span>
          <strong>Compare fairly</strong>
          <p>The dates you pick, the period before, and the longer view.</p>
        </div>
        <div>
          <span>02</span>
          <strong>See the evidence</strong>
          <p>Trace the story back to its data and coverage.</p>
        </div>
        <div>
          <span>03</span>
          <strong>Make it yours</strong>
          <p>Steer with a prompt. Edit, save, and share.</p>
        </div>
      </div>
      {!modelAvailable && (
        <div className={reportClass("message preview-message")}>
          <CircleAlert size={16} />
          The model is not configured. Generation will report its available
          mode.
        </div>
      )}
      <span className={reportClass("empty-hint")}>
        <ArrowLeft size={15} />
        Set your recipe and generate your notebook.
      </span>
    </div>
  )
}

/** Shown in place of the document when the workspace itself could not be loaded. */
export function ReportUnavailableState({ onRetry }: { onRetry: () => void }) {
  return (
    <div className={reportClass("empty-state")}>
      <h2>Notebooks are unavailable.</h2>
      <p>The workspace could not be loaded. Retry to reconnect to Sofia.</p>
      <Button onClick={onRetry}>Retry connection</Button>
    </div>
  )
}
